module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic11.f4f6511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic11.png
// module id = 562
// module chunks = 1